import React from 'react';
import { ForwardOptionsWrapper } from '../_parts/ForwardOptionsWrapper';
import { useSelector } from 'react-redux';
import {
    getCurrentTabsForwardingData,
    getDocuments,
    getForwardTabs,
} from '../../../../../redux/project/sliceProjectWorkflow';
import { IAppReduxStore } from '../../../../../redux/store';
import { Stack, SxProps, Typography } from '@mui/material';
import { headingFontBold } from '../../../../../Theme';
import { useTranslation } from 'react-i18next';

/** Styles for Typography. */
const typographySx: SxProps = {
    pr: 0.5,
    ...headingFontBold,
};

export default ({ mainState, getStateChanged, hasError }) => {
    const { t } = useTranslation('translations', { keyPrefix: 'mainDialog' });
    const forwardData = useSelector(getCurrentTabsForwardingData);
    const selectedTab = useSelector((_store: IAppReduxStore) => _store.projectWorkflow.selectedTab);

    const tabs = useSelector(getForwardTabs);
    const documents = useSelector(getDocuments);

    return (
        <>
            {documents.length > 0 && (
                <>
                    <Stack
                        direction='row'
                        sx={{
                            alignItems: 'center',
                            mb: 1,
                        }}
                    >
                        <Typography component='span' sx={typographySx}>
                            {t('forwardTo')}
                        </Typography>
                    </Stack>
                    {tabs?.[selectedTab]?.name && (
                        <ForwardOptionsWrapper
                            data={forwardData}
                            selected={mainState}
                            parentValue={tabs[selectedTab].name}
                            getStateChanged={getStateChanged}
                            hasError={hasError}
                        />
                    )}
                </>
            )}
        </>
    );
};
